import React from 'react';

import styles from './ToggleSelector.module.css';

export default function({
  label,
  value,
  onChange,
  labelPositionRight = false,
  customParentStyle,
  customLabelStyle
}) {
  return <div className={`${styles.singleProperty} ${customParentStyle}`}>
    {!labelPositionRight ? (
      <span className={customLabelStyle}>{label}</span>
    ) : null}
    <span role="presentation">
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className={styles.switch} htmlFor="checkbox">
        <input type="checkbox" checked={value} readOnly />
        <span
          className="slider round"
          role="presentation"
          onClick={e => {
            onChange(!value);
            e.stopPropagation();
          }}
        />
      </label>
    </span>
    {labelPositionRight ? (
      <span className={customLabelStyle}>{label}</span>
    ) : null}
  </div>
};
